import * as React from "react";
const SvgSortUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 6, viewBox: "0 0 8 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7 4.5L4 1.5L1 4.5", stroke: "#2D2D2D", strokeWidth: 1.5, strokeLinecap: "round" }));
export default SvgSortUp;
